import { createBrowserRouter, Navigate } from 'react-router-dom';
import App from './App';
import Games from './games/Games';
import Business from './business/Business';
import About from './about/About';
import { ROUTES } from './constants/routes';

// 创建路由配置
export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to={ROUTES.GAMES} replace />,
      },
      {
        path: ROUTES.GAMES,
        element: <Games />,
      },
      {
        path: ROUTES.BUSINESS,
        element: <Business />,
      },
      {
        path: ROUTES.ABOUT,
        element: <About />,
      },
    ],
  },
]);

